import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Rubro } from "@/shared/types/rubro";

export interface RubroAddRequest {
    nombre: string,
}

export async function addRubro(request: RubroAddRequest): Promise<Rubro> {
    await sleep(1000);
    const response = await api.post("rubros", request);
    return response.data;
}

export function useAddRubroMutation(mutationConfig: MutationConfig<Rubro, RubroAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addRubro,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["rubros"] });
        },
    })
}

export interface AddRubroMutationProps {
    mutationConfig?: MutationConfig<Rubro, RubroAddRequest>
    children?: (mutationResult: MutationResult<Rubro, RubroAddRequest>) => ReactNode
}

export function AddRubroMutation({
    mutationConfig,
    children
}: AddRubroMutationProps) {
    const mutationResult = useAddRubroMutation(mutationConfig);
    return children && children(mutationResult);
}